const shipToSeal = {
  shiptoNo: 'ShiptoNo',
  shiptoName: 'ShiptoName',
  description: 'Description',
  sealUrl: 'SealImage',
  attachmentUrl: 'Attachment',
  msg: {}
};
export default shipToSeal;



// WEBPACK FOOTER //
// ./src/page/md/shipToSeal/lang/shipToSeal.en.js